import styled, { css } from 'styled-components'
import { BorderType } from 'common/types/styleTypes'
import {
  borderCss,
  boxShadowCss,
  mobileBorderCss,
  mobileBoxShadowCss,
} from 'common/utils/styleUtilsNew'

type VideoContainerUiProps = {
  border?: Partial<BorderType>
  mobileBorder?: Partial<BorderType>
  boxShadow?: string
  mobileBoxShadow?: string
}

export const VideoContainerUi = styled.div<VideoContainerUiProps>`
  overflow: hidden;
  ${borderCss};
  ${boxShadowCss};

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileBorderCss};
      ${mobileBoxShadowCss};
    `}
  ${p => p.theme.phone} {
    ${mobileBorderCss};
    ${mobileBoxShadowCss};
  }
`
